export const environment = {
    production: true,
    settings: {
        storeApiUrl: 'http://localhost:49420/api/',
        gwamAppApiUrl: 'http://localhost:9010/api/',
        industriesServiceUrl: 'http://localhost:10200/industries-manager/',
        cmsServiceUrl: 'http://localhost:10200/cms-manager-controller/',
        helpMagoCloudStore: 'http://m4ctest-help-store.s3-website-eu-west-1.amazonaws.com/',
        microareaserviceproxy: 'http://vintage.microarea.it/MicroareaServiceProxy.Test/',
        editorServiceUrl: 'http://localhost:10200/editor/',
        translateServiceUrl: 'http://localhost:10200/translate/',
        researchServiceUrl: 'http://localhost:10200/research/',
        industryServiceUrl: 'http://localhost:10200/industry/',
        authUrl: 'https://localhost:49420/api',
        landingUrlAfterMYZLogin: 'http://localhost:4200/cas-account',
        helpCenterApiUrl: 'http://localhost:49420/MagoHelpCenter/',
        universityBaseUrl: 'http://localhost:4200/'
    },
    auth: {
        url: 'http://localhost:49420/api/',
        appId: 'ST', // variabile non strettamente necessaria, è possibile cablarla nel codice di login
        authToken: 'cVsYiT1g699Uq8PW',
        sessionStorage: false,
    },
};
